import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { goHome } from 'modules/steps/actions';
import { resetContext } from 'store/globalState/global';
import UsersProfiles from '../components/UsersProfiles';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.usersProfiles,
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    goHome: bindActionCreators(goHome, dispatch),
    resetContext: bindActionCreators(resetContext, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UsersProfiles),
);



// WEBPACK FOOTER //
// ./src/routes/UsersProfiles/container/index.js